import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import client from "@/lib/api";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminSidebar, { ADMIN_NAV } from "@/components/admin/AdminSidebar";
import DashboardModule from "@/components/admin/DashboardModule";
import MenuModule from "@/components/admin/MenuModule";
import SpecialsModule from "@/components/admin/SpecialsModule";
import OrdersModule from "@/components/admin/OrdersModule";
import SiteSettingsModule from "@/components/admin/SiteSettingsModule";
import PageContentModule from "@/components/admin/PageContentModule";
import UsersModule from "@/components/admin/UsersModule";

function ModuleFor({ section, me, refreshCounts }) {
    switch (section) {
        case "menu": return <MenuModule />;
        case "specials": return <SpecialsModule />;
        case "orders": return <OrdersModule onCountsChange={refreshCounts} />;
        case "settings": return <SiteSettingsModule />;
        case "content": return <PageContentModule />;
        case "users": return <UsersModule me={me} />;
        default: return <DashboardModule />;
    }
}

export default function Admin() {
    const { section = "dashboard" } = useParams();
    const nav = useNavigate();
    const [authed, setAuthed] = useState(!!localStorage.getItem("uk_admin_token"));
    const [me, setMe] = useState(null);
    const [inboxCount, setInboxCount] = useState(0);

    const refreshCounts = useCallback(() => {
        client.get("/admin/dashboard").then((r) => setInboxCount(r.data.new_orders + r.data.new_enquiries)).catch(() => {});
    }, []);

    useEffect(() => {
        if (!authed) return;
        client.get("/admin/me")
            .then((r) => setMe(r.data))
            .catch(() => { localStorage.removeItem("uk_admin_token"); setAuthed(false); });
    }, [authed]);

    useEffect(() => {
        if (!me) return;
        refreshCounts();
        const t = setInterval(refreshCounts, 30000);
        return () => clearInterval(t);
    }, [me, refreshCounts]);

    if (!authed) return <AdminLogin onLogin={() => setAuthed(true)} />;
    if (!me) return <div className="min-h-screen flex items-center justify-center text-brand-mute">Loading…</div>;
    if (!ADMIN_NAV.some((n) => n.key === section)) return <Navigate to="/admin" replace />;

    const logout = () => {
        localStorage.removeItem("uk_admin_token");
        setAuthed(false);
        setMe(null);
        nav("/admin");
    };

    return (
        <div className="min-h-screen bg-brand-ink" data-testid="admin-shell">
            <AdminSidebar active={section} me={me} onLogout={logout} inboxCount={inboxCount} />
            <div className="lg:pl-64">
                <main key={section} className="px-5 sm:px-8 lg:px-12 py-8 lg:py-12 max-w-[1400px] admin-fade">
                    <ModuleFor section={section} me={me} refreshCounts={refreshCounts} />
                </main>
            </div>
        </div>
    );
}
